import React, { useState } from "react";
import styled from "styled-components";
import { pixelize, UNIT, PADDING_X_LARGE_PX, MARGING_LARGE_PX, PADDING_XX_LARGE_PX, MARGING_SMALL_PX, MARGING_LARGE } from "constants/size";
import { Input } from "App/Atomics/Input";
import { WHITE, GRAY_4, GRAY_0 } from "constants/baseColor";
import { LanguageTextSelect } from "App/Molecules/Selects/Language";
import { useAlbumDetailStore, useAlbumDetailSelector } from "../../Store";
import { TitleTypeOptionInfo } from "constants/TypeOptionInfo";
import { LanguageCodeInfo } from "constants/LanguageCodeInfo";

type Props = {
  onUpdate: (id: string, type: string, value: string, languageCode: string) => void;
  toClose: () => void;
};

type Title = {
  id: string;
  order: string;
  type: string;
  value: string;
  language: [
    {
      languageCode: string;
    }
  ];
};

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  width: ${pixelize(UNIT * 35)};
  height: ${pixelize(UNIT * 38.5)};
  padding: ${PADDING_XX_LARGE_PX};
  border-radius: 4px;
  overflow: hidden;
  background-color: ${GRAY_0};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Multiline = styled.textarea`
  width: 100%;
  height: ${pixelize(UNIT * 17.5)};
  font-size: 14px;
  background-color: ${WHITE};
  border: 1px solid ${GRAY_4};
  border-radius: 4px;
  margin-bottom: ${MARGING_LARGE_PX};
  padding: ${PADDING_X_LARGE_PX};
`;

const RowGroup = styled.div`
  width: 100%;
  h2 {
    font-size: 20px;
    margin: ${pixelize(MARGING_LARGE * 1.5)} 0;
  }
  h4 {
    font-size: 14px;
    margin: ${MARGING_LARGE_PX} 0;
  }

  .typeSelect {
    margin-bottom: ${MARGING_LARGE_PX};
    font-size: 12px;
  }
`;

const LanguageSelect = styled(LanguageTextSelect)`
  font-size: 0.8rem;
  margin-bottom: ${MARGING_LARGE_PX};
`;

const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  margin: ${MARGING_SMALL_PX} ${MARGING_LARGE_PX};
  font-weight: bold;
  .cancelButton {
    margin-left: ${MARGING_LARGE_PX};
  }
`;

export const UpdateInputModal = ({ onUpdate, toClose }: Props) => {
  const modalId = useAlbumDetailSelector(store => store.AlbumDetail.modalId);
  const [{ titleRelation }] = useAlbumDetailStore(store => ({
    titleRelation: store.AlbumDetail.albumDetail[0].album[0].titleRelation.filter((title: Title) => title.id === modalId)[0]
  }));
  const [type, setType] = useState<string>(titleRelation.type);
  const [languageCode, setLanguageCode] = useState<string>(titleRelation.language[0].languageCode);
  const [description, setDescription] = useState<string>(titleRelation.value);

  return (
    <Layout>
      <RowGroup>
        <h2>수정</h2>
      </RowGroup>
      <RowGroup>
        <h4>타입 선택</h4>
        <Input.TextSelect
          className="typeSelect"
          optionList={TitleTypeOptionInfo}
          defaultValue={{ id: type, name: type }}
          onChange={info => {
            if (info) {
              setType(info.id);
            }
          }}
        />
      </RowGroup>
      <RowGroup>
        <h4>언어 선택</h4>
        <LanguageSelect
          defaultValue={LanguageCodeInfo.find(({ id }) => id === languageCode)}
          onChange={code => {
            if (code) {
              setLanguageCode(code.id);
            }
          }}
        />
      </RowGroup>
      <RowGroup>
        <h4>앨범 설명</h4>
        <Multiline
          placeholder="설명을 입력하세요"
          defaultValue={decodeURIComponent(description)}
          onChange={e => setDescription(e.target.value)}
        />
      </RowGroup>
      <ButtonGroup>
        <Input.Button className="cancelButton" onClick={toClose}>
          취소
        </Input.Button>
        <Input.Button onClick={() => onUpdate(modalId, type, description, languageCode)}>저장</Input.Button>
      </ButtonGroup>
    </Layout>
  );
};
